<script>
  import SideNavItems from "carbon-components-svelte/src/UIShell/SideNav/SideNavItems.svelte";
import SideNavLink from "carbon-components-svelte/src/UIShell/SideNav/SideNavLink.svelte";

  export let selected;
  export let offset = 50;
  export let href = "/about/";
  export let center = true;
  export let isSticky = true;
  export let items = [
    {
      id: "section1",
      label: "Section 1",
    },
    {
      id: "section2",
      label: "Section 2",
    },
  ];
  export let zIndex = 2;

  function scrollTo(e, id) {
    e.preventDefault();
    selected = id;
    const el = document.getElementById(selected);
    window.scrollTo({
      top: el.offsetTop - offset,
      behavior: "smooth",
    });
  }
</script>

<style lang="scss">:root {
  --white: #ffffff;
  --black: #090f20;
  --accent: #6be7ba;
  --gray-10: #fafbfb;
  --gray-20: #eaecee;
  --gray-30: #bcc2c7;
  --gray-40: #9fa6ac;
  --gray-50: #838b92;
  --gray-60: #697178;
  --gray-70: #51585e;
  --gray-80: #3b4045;
  --gray-90: #26292c;
  --gray-100: #121416;
  --blue-40: #074e67;
  --blue-50: #003850;
  --blue-60: #002448;
  --blue-70: #001440;
  --teal-10: #cce4e4;
  --teal-20: #9ac9ca;
  --teal-30: #68aeb0;
  --teal-40: #369396;
  --teal-50: #1d8689;
  --teal-60: #04797c;
  --teal-70: #036063;
  --teal-80: #02484a;
  --teal-90: #013031;
  --teal-100: #001818;
  --rs-green: #5dfa25;
  --rs-blue: #25c7fa;
  --rs-teal: #88dcc4;
  --card-gradient-01: linear-gradient(180deg, #187a45 0%, #125949 71.35%, #0d4034 97.4%);
  --card-gradient-02: linear-gradient(180deg, #197d7f 0%, #017f77 0.01%, #145066 72.92%, #0f3c4d 100%);
  --card-gradient-03: linear-gradient(180deg, #1f7799 0%, #195380 76.04%, #143466 100%);
  --gradient-gray-blue: linear-gradient(to bottom, #26292c 0%, #262b30 8.1%, #262e33 15.5%, #253037 22.5%, #25333b 29%, #24353f 35.3%, #233743 41.2%, #223a47 47.1%, #213c4b 52.9%, #1f3f4f 58.8%, #1d4153 64.7%, #1b4457 71%, #18465b 77.5%, #14495f 84.5%, #0f4b63 91.9%, #074e67 100%);
  --interactive-01: #04797c;
  --interactive-02: #002448;
  --interactive-03: #04797c;
  --interactive-04: #04797c;
  --ui-background: rgba(250, 251, 251, 0.5);
  --ui-01: #ffffff;
  --ui-02: #fafbfb;
  --ui-03: #eaecee;
  --ui-04: #838b92;
  --ui-05: #121416;
  --text-01: #121416;
  --text-02: #51585e;
  --text-03: #9fa6ac;
  --text-04: #ffffff;
  --icon-01: #121416;
  --icon-02: #51585e;
  --icon-03: #ffffff;
  --link-01: #015afe;
  --link-02: #0043ce;
  --field-01: #ffffff;
  --field-02: #fafbfb;
  --inverse-01: #ffffff;
  --inverse-02: #3b4045;
  --support-01: #df4759;
  --support-02: #24a148;
  --support-03: #fdd13a;
  --support-04: #04797c;
  --inverse-support-01: #fb4b53;
  --inverse-support-02: #3dbb61;
  --inverse-support-03: #fdd13a;
  --inverse-support-04: #9ac9ca;
  --overlay-01: rgba(23, 23, 23, 0.5);
  --focus: #002448;
  --hover-primary: #036063;
  --active-primary: #036063;
  --hover-primary-text: #121416;
  --hover-secondary: #003850;
  --active-secondary: #001440;
  --hover-tertiary: #04797c;
  --active-tertiary: #04797c;
  --hover-ui: #fafbfb;
  --active-ui: #bcc2c7;
  --selected-ui: #eaecee;
  --hover-selected-ui: #bcc2c7;
  --hover-danger: #ba1b23;
  --active-danger: #750e13;
  --hover-row: #fafbfb;
  --visited-link: #8a3ffc;
  --disabled-01: #ffffff;
  --disabled-02: #9ac9ca;
  --disabled-03: #51585e;
  --highlight: #c9deff;
  --skeleton-01: #eaecee;
  --skeleton-02: #bcc2c7;
  --active-01: #04797c;
  --hover-field: #e5e5e5;
  --box-shadow: 0 0.125rem 0.25rem rgba(9, 15, 32, 0.075);
  --box-shadow-lift: 0 1rem 2.5rem rgba(9, 15, 32, 0.1), 0 0.5rem 1rem -0.75rem rgba(9, 15, 32, 0.1);
  --border-radius: 0.175rem;
  --spacing-1: 0.0625rem;
  --spacing-2: 0.125rem;
  --spacing-4: 0.25rem;
  --spacing-8: 0.5rem;
  --spacing-12: 0.75rem;
  --spacing-16: 1rem;
  --spacing-24: 1.5rem;
  --spacing-32: 2rem;
  --spacing-40: 2.5rem;
  --spacing-48: 3rem;
  --spacing-64: 4rem;
  --spacing-96: 6rem;
  --spacing-160: 10rem;
  --p-default-max-width: 75ch;
  --p-lead-default-max-width: 55ch;
  --gcm-ACCESS1-0: #1f77b4;
  --gcm-CanESM2: #bcbd22;
  --gcm-CCSM4: #2ca02c;
  --gcm-CESM1-BGC: #8c564b;
  --gcm-CMCC-CMS: #e377c2;
  --gcm-CNRM-CM5: #17becf;
  --gcm-GFDL-CM3: #ff7f0e;
  --gcm-HadGEM2-CC: #454444;
  --gcm-HadGEM2-ES: #d62728;
  --gcm-MIROC5: #9467bd; }

.page-nav {
  width: 100%;
  background: #fafbfb;
  border-bottom: 1px solid #dadee1;
  background: #dadee1;
  top: 0;
  z-index: var(--z-index); }

.page-nav :global(.bx--side-nav__items) {
  display: flex;
  flex-wrap: wrap;
  padding: 0; }

.page-nav.center :global(.bx--side-nav__items) {
  justify-content: center; }

.page-nav :global(.bx--side-nav__link-text) {
  font-size: 1rem;
  text-transform: uppercase; }

.page-nav :global(.bx--side-nav__link[aria-current="page"]::before),
.page-nav :global(.bx--side-nav__link--current::before) {
  width: 100%;
  height: 2px;
  top: 93%; }

@media (max-width: 62.5rem) {
  .page-nav :global(.bx--side-nav__items) {
    flex-direction: column; } }
</style>

<div
  class="page-nav shadow"
  class:is-sticky="{isSticky}"
  class:center
  style="--z-index:{zIndex}"
>
  <SideNavItems>
    {#each items as item}
      <SideNavLink
        isSelected="{selected === item.id}"
        href="{`${href}#${item.id}`}"
        text="{item.label}"
        on:click="{(e) => scrollTo(e, item.id)}"
      />
    {/each}
  </SideNavItems>
</div>
